/**
 * ContactsApiService — API-first contact operations.
 */

import { ApiClient } from '../ApiClient.js';

export class ContactsApiService {
    static async list({ page = 1, per_page = 50, client_id = null } = {}) {
        const params = { page, per_page };
        if (client_id) params.client_id = client_id;
        return ApiClient.get('/api/v1/contacts', params);
    }

    static async getById(contactId) {
        return ApiClient.get(`/api/v1/contacts/${encodeURIComponent(contactId)}`);
    }

    static async create(payload) {
        return ApiClient.post('/api/v1/contacts', payload);
    }

    static async update(contactId, payload) {
        return ApiClient.put(`/api/v1/contacts/${encodeURIComponent(contactId)}`, payload);
    }

    static async softDelete(contactId) {
        return ApiClient.delete(`/api/v1/contacts/${encodeURIComponent(contactId)}`);
    }

    static async restore(contactId) {
        return ApiClient.post(`/api/v1/contacts/${encodeURIComponent(contactId)}/restore`, {});
    }
}

